export const STATE_NAMES = {
  AL: 'Alabama',
  AK: 'Alaska',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DE: 'Delaware',
  DC: 'District of Columbia',
  FL: 'Florida',
  GA: 'Georgia',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VA: 'Virginia',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming'
}

// US geographic area codes (code -> primary city + state + city-centre lat/lng). Generated and
// adversarially verified per region; keep sorted by area_code.
export const US_AREA_CODES = [
  { area_code: '201', city: 'Jersey City', state: 'NJ', lat: 40.7114, lng: -74.0648 },
  { area_code: '202', city: 'Washington', state: 'DC', lat: 38.9042, lng: -77.0165 },
  { area_code: '203', city: 'Bridgeport', state: 'CT', lat: 41.1874, lng: -73.1958 },
  { area_code: '205', city: 'Birmingham', state: 'AL', lat: 33.5272, lng: -86.797 },
  { area_code: '206', city: 'Seattle', state: 'WA', lat: 47.6193, lng: -122.3515 },
  { area_code: '207', city: 'Portland', state: 'ME', lat: 43.6332, lng: -70.1853 },
  { area_code: '208', city: 'Boise', state: 'ID', lat: 43.5993, lng: -116.2298 },
  { area_code: '209', city: 'Stockton', state: 'CA', lat: 37.9766, lng: -121.3086 },
  { area_code: '210', city: 'San Antonio', state: 'TX', lat: 29.4628, lng: -98.5246 },
  { area_code: '212', city: 'New York City', state: 'NY', lat: 40.7143, lng: -74.006 },
  { area_code: '213', city: 'Los Angeles', state: 'CA', lat: 34.0522, lng: -118.2437 },
  { area_code: '214', city: 'Dallas', state: 'TX', lat: 32.7933, lng: -96.7665 },
  { area_code: '215', city: 'Philadelphia', state: 'PA', lat: 40.0094, lng: -75.1333 },
  { area_code: '216', city: 'Cleveland', state: 'OH', lat: 41.4785, lng: -81.6794 },
  { area_code: '217', city: 'Springfield', state: 'IL', lat: 39.7911, lng: -89.6446 },
  { area_code: '218', city: 'Duluth', state: 'MN', lat: 46.7745, lng: -92.1341 },
  { area_code: '219', city: 'Gary', state: 'IN', lat: 41.5907, lng: -87.3471 },
  { area_code: '220', city: 'Newark', state: 'OH', lat: 40.0715, lng: -82.4242 },
  { area_code: '223', city: 'Harrisburg', state: 'PA', lat: 40.2759, lng: -76.885 },
  { area_code: '224', city: 'Waukegan', state: 'IL', lat: 42.3694, lng: -87.8709 },
  { area_code: '225', city: 'Baton Rouge', state: 'LA', lat: 30.4404, lng: -91.1332 },
  { area_code: '227', city: 'Silver Spring', state: 'MD', lat: 39.0024, lng: -77.0208 },
  { area_code: '228', city: 'Biloxi', state: 'MS', lat: 30.4267, lng: -88.9358 },
  { area_code: '229', city: 'Albany', state: 'GA', lat: 31.5781, lng: -84.1762 },
  { area_code: '231', city: 'Traverse City', state: 'MI', lat: 44.7543, lng: -85.603 },
  { area_code: '234', city: 'Akron', state: 'OH', lat: 41.0805, lng: -81.5214 },
  { area_code: '239', city: 'Fort Myers', state: 'FL', lat: 26.6198, lng: -81.8317 },
  { area_code: '240', city: 'Silver Spring', state: 'MD', lat: 39.0024, lng: -77.0208 },
  { area_code: '248', city: 'Troy', state: 'MI', lat: 42.5839, lng: -83.1455 },
  { area_code: '251', city: 'Mobile', state: 'AL', lat: 30.6682, lng: -88.1079 },
  { area_code: '252', city: 'Greenville', state: 'NC', lat: 35.5964, lng: -77.3753 },
  { area_code: '253', city: 'Tacoma', state: 'WA', lat: 47.2522, lng: -122.4598 },
  { area_code: '254', city: 'Waco', state: 'TX', lat: 31.558, lng: -97.1898 },
  { area_code: '256', city: 'Huntsville', state: 'AL', lat: 34.7304, lng: -86.5859 },
  { area_code: '260', city: 'Fort Wayne', state: 'IN', lat: 41.0882, lng: -85.1428 },
  { area_code: '262', city: 'Kenosha', state: 'WI', lat: 42.5875, lng: -87.88 },
  { area_code: '267', city: 'Philadelphia', state: 'PA', lat: 40.0094, lng: -75.1333 },
  { area_code: '269', city: 'Kalamazoo', state: 'MI', lat: 42.2752, lng: -85.5885 },
  { area_code: '270', city: 'Bowling Green', state: 'KY', lat: 36.9768, lng: -86.4337 },
  { area_code: '272', city: 'Scranton', state: 'PA', lat: 41.4042, lng: -75.6659 },
  { area_code: '276', city: 'Bristol', state: 'VA', lat: 36.617, lng: -82.1576 },
  { area_code: '279', city: 'Sacramento', state: 'CA', lat: 38.5677, lng: -121.4682 },
  { area_code: '281', city: 'Houston', state: 'TX', lat: 29.7857, lng: -95.3888 },
  { area_code: '283', city: 'Cincinnati', state: 'OH', lat: 39.1402, lng: -84.5058 },
  { area_code: '301', city: 'Silver Spring', state: 'MD', lat: 39.0024, lng: -77.0208 },
  { area_code: '302', city: 'Wilmington', state: 'DE', lat: 39.7357, lng: -75.5321 },
  { area_code: '303', city: 'Denver', state: 'CO', lat: 39.7392, lng: -104.9847 },
  { area_code: '304', city: 'Charleston', state: 'WV', lat: 38.3487, lng: -81.6323 },
  { area_code: '305', city: 'Miami', state: 'FL', lat: 25.7752, lng: -80.2086 },
  { area_code: '307', city: 'Cheyenne', state: 'WY', lat: 41.1287, lng: -104.7908 },
  { area_code: '308', city: 'North Platte', state: 'NE', lat: 41.125, lng: -100.7504 },
  { area_code: '309', city: 'Peoria', state: 'IL', lat: 40.7516, lng: -89.6172 },
  { area_code: '310', city: 'Los Angeles', state: 'CA', lat: 34.0522, lng: -118.2437 },
  { area_code: '312', city: 'Chicago', state: 'IL', lat: 41.837, lng: -87.6849 },
  { area_code: '313', city: 'Detroit', state: 'MI', lat: 42.383, lng: -83.1022 },
  { area_code: '314', city: 'St. Louis', state: 'MO', lat: 38.6357, lng: -90.2446 },
  { area_code: '315', city: 'Syracuse', state: 'NY', lat: 43.041, lng: -76.1436 },
  { area_code: '316', city: 'Wichita', state: 'KS', lat: 37.6906, lng: -97.3458 },
  { area_code: '317', city: 'Indianapolis', state: 'IN', lat: 39.7767, lng: -86.1459 },
  { area_code: '318', city: 'Shreveport', state: 'LA', lat: 32.4669, lng: -93.7922 },
  { area_code: '319', city: 'Cedar Rapids', state: 'IA', lat: 41.9642, lng: -91.6792 },
  { area_code: '320', city: 'St. Cloud', state: 'MN', lat: 45.5267, lng: -94.171 },
  { area_code: '321', city: 'Melbourne', state: 'FL', lat: 28.1104, lng: -80.6627 },
  { area_code: '323', city: 'Los Angeles', state: 'CA', lat: 34.0522, lng: -118.2437 },
  { area_code: '325', city: 'Abilene', state: 'TX', lat: 32.4545, lng: -99.7381 },
  { area_code: '326', city: 'Dayton', state: 'OH', lat: 39.7847, lng: -84.1996 },
  { area_code: '327', city: 'Jonesboro', state: 'AR', lat: 35.8198, lng: -90.679 },
  { area_code: '329', city: 'Sacramento', state: 'CA', lat: 38.5677, lng: -121.4682 },
  { area_code: '330', city: 'Akron', state: 'OH', lat: 41.0805, lng: -81.5214 },
  { area_code: '331', city: 'Aurora', state: 'IL', lat: 41.7635, lng: -88.2901 },
  { area_code: '332', city: 'New York City', state: 'NY', lat: 40.7143, lng: -74.006 },
  { area_code: '334', city: 'Montgomery', state: 'AL', lat: 32.3485, lng: -86.2673 },
  { area_code: '336', city: 'Greensboro', state: 'NC', lat: 36.0949, lng: -79.8236 },
  { area_code: '337', city: 'Lafayette', state: 'LA', lat: 30.2056, lng: -92.0281 },
  { area_code: '339', city: 'Newton', state: 'MA', lat: 42.3318, lng: -71.2084 },
  { area_code: '341', city: 'Oakland', state: 'CA', lat: 37.7698, lng: -122.2257 },
  { area_code: '346', city: 'Houston', state: 'TX', lat: 29.7857, lng: -95.3888 },
  { area_code: '347', city: 'New York City', state: 'NY', lat: 40.7143, lng: -74.006 },
  { area_code: '350', city: 'Stockton', state: 'CA', lat: 37.9766, lng: -121.3086 },
  { area_code: '351', city: 'Lowell', state: 'MA', lat: 42.639, lng: -71.321 },
  { area_code: '352', city: 'Gainesville', state: 'FL', lat: 29.6795, lng: -82.3468 },
  { area_code: '353', city: 'Milwaukee', state: 'WI', lat: 43.0633, lng: -87.9667 },
  { area_code: '360', city: 'Vancouver', state: 'WA', lat: 45.6372, lng: -122.5966 },
  { area_code: '361', city: 'Corpus Christi', state: 'TX', lat: 27.8006, lng: -97.3964 },
  { area_code: '363', city: 'Hempstead', state: 'NY', lat: 40.7044, lng: -73.6194 },
  { area_code: '364', city: 'Bowling Green', state: 'KY', lat: 36.9768, lng: -86.4337 },
  { area_code: '380', city: 'Columbus', state: 'OH', lat: 39.9839, lng: -82.9849 },
  { area_code: '385', city: 'Salt Lake City', state: 'UT', lat: 40.7769, lng: -111.931 },
  { area_code: '386', city: 'Daytona Beach', state: 'FL', lat: 29.1907, lng: -81.0971 },
  { area_code: '401', city: 'Providence', state: 'RI', lat: 41.8231, lng: -71.4188 },
  { area_code: '402', city: 'Omaha', state: 'NE', lat: 41.2563, lng: -95.9404 },
  { area_code: '404', city: 'Atlanta', state: 'GA', lat: 33.7629, lng: -84.4227 },
  { area_code: '405', city: 'Oklahoma City', state: 'OK', lat: 35.4671, lng: -97.5137 },
  { area_code: '406', city: 'Billings', state: 'MT', lat: 45.7885, lng: -108.5525 },
  { area_code: '407', city: 'Orlando', state: 'FL', lat: 28.5383, lng: -81.3792 },
  { area_code: '408', city: 'San Jose', state: 'CA', lat: 37.3394, lng: -121.895 },
  { area_code: '409', city: 'Beaumont', state: 'TX', lat: 30.0849, lng: -94.1453 },
  { area_code: '410', city: 'Baltimore', state: 'MD', lat: 39.3, lng: -76.6105 },
  { area_code: '412', city: 'Pittsburgh', state: 'PA', lat: 40.4399, lng: -79.9757 },
  { area_code: '413', city: 'Springfield', state: 'MA', lat: 42.1155, lng: -72.54 },
  { area_code: '414', city: 'Milwaukee', state: 'WI', lat: 43.0633, lng: -87.9667 },
  { area_code: '415', city: 'San Francisco', state: 'CA', lat: 37.7749, lng: -122.4194 },
  { area_code: '417', city: 'Springfield', state: 'MO', lat: 37.1942, lng: -93.2926 },
  { area_code: '419', city: 'Toledo', state: 'OH', lat: 41.6641, lng: -83.5819 },
  { area_code: '423', city: 'Chattanooga', state: 'TN', lat: 35.066, lng: -85.2484 },
  { area_code: '424', city: 'Los Angeles', state: 'CA', lat: 34.0522, lng: -118.2437 },
  { area_code: '425', city: 'Bellevue', state: 'WA', lat: 47.5978, lng: -122.1565 },
  { area_code: '430', city: 'Tyler', state: 'TX', lat: 32.3173, lng: -95.3059 },
  { area_code: '432', city: 'Midland', state: 'TX', lat: 32.0246, lng: -102.1135 },
  { area_code: '434', city: 'Charlottesville', state: 'VA', lat: 38.0377, lng: -78.4854 },
  { area_code: '435', city: 'St. George', state: 'UT', lat: 37.077, lng: -113.5765 },
  { area_code: '440', city: 'Cleveland', state: 'OH', lat: 41.4785, lng: -81.6794 },
  { area_code: '442', city: 'Palm Springs', state: 'CA', lat: 33.8034, lng: -116.5383 },
  { area_code: '443', city: 'Baltimore', state: 'MD', lat: 39.3, lng: -76.6105 },
  { area_code: '445', city: 'Philadelphia', state: 'PA', lat: 40.0094, lng: -75.1333 },
  { area_code: '447', city: 'Springfield', state: 'IL', lat: 39.7911, lng: -89.6446 },
  { area_code: '448', city: 'Pensacola', state: 'FL', lat: 30.441, lng: -87.1912 },
  { area_code: '458', city: 'Eugene', state: 'OR', lat: 44.0568, lng: -123.119 },
  { area_code: '463', city: 'Indianapolis', state: 'IN', lat: 39.7767, lng: -86.1459 },
  { area_code: '464', city: 'Cicero', state: 'IL', lat: 41.8445, lng: -87.7593 },
  { area_code: '469', city: 'Dallas', state: 'TX', lat: 32.7933, lng: -96.7665 },
  { area_code: '470', city: 'Atlanta', state: 'GA', lat: 33.7629, lng: -84.4227 },
  { area_code: '475', city: 'Bridgeport', state: 'CT', lat: 41.1874, lng: -73.1958 },
  { area_code: '478', city: 'Macon', state: 'GA', lat: 32.809, lng: -83.6941 },
  { area_code: '479', city: 'Fort Smith', state: 'AR', lat: 35.3493, lng: -94.3709 },
  { area_code: '480', city: 'Mesa', state: 'AZ', lat: 33.4223, lng: -111.8226 },
  { area_code: '484', city: 'Allentown', state: 'PA', lat: 40.5936, lng: -75.4784 },
  { area_code: '501', city: 'Little Rock', state: 'AR', lat: 34.7254, lng: -92.3586 },
  { area_code: '502', city: 'Louisville', state: 'KY', lat: 38.2247, lng: -85.7406 },
  { area_code: '503', city: 'Portland', state: 'OR', lat: 45.537, lng: -122.65 },
  { area_code: '504', city: 'New Orleans', state: 'LA', lat: 29.9547, lng: -90.0751 },
  { area_code: '505', city: 'Albuquerque', state: 'NM', lat: 35.1048, lng: -106.6468 },
  { area_code: '507', city: 'Rochester', state: 'MN', lat: 44.0143, lng: -92.4786 },
  { area_code: '508', city: 'Worcester', state: 'MA', lat: 42.2695, lng: -71.8078 },
  { area_code: '509', city: 'Spokane', state: 'WA', lat: 47.6669, lng: -117.4333 },
  { area_code: '510', city: 'Oakland', state: 'CA', lat: 37.7698, lng: -122.2257 },
  { area_code: '512', city: 'Austin', state: 'TX', lat: 30.2986, lng: -97.7541 },
  { area_code: '513', city: 'Cincinnati', state: 'OH', lat: 39.1402, lng: -84.5058 },
  { area_code: '515', city: 'Des Moines', state: 'IA', lat: 41.5726, lng: -93.6102 },
  { area_code: '516', city: 'Hempstead', state: 'NY', lat: 40.7044, lng: -73.6194 },
  { area_code: '517', city: 'Lansing', state: 'MI', lat: 42.7143, lng: -84.5609 },
  { area_code: '518', city: 'Albany', state: 'NY', lat: 42.6657, lng: -73.7984 },
  { area_code: '520', city: 'Tucson', state: 'AZ', lat: 32.2217, lng: -110.9265 },
  { area_code: '530', city: 'Redding', state: 'CA', lat: 40.5703, lng: -122.3668 },
  { area_code: '531', city: 'Omaha', state: 'NE', lat: 41.2563, lng: -95.9404 },
  { area_code: '534', city: 'Eau Claire', state: 'WI', lat: 44.8183, lng: -91.4948 },
  { area_code: '539', city: 'Tulsa', state: 'OK', lat: 36.154, lng: -95.9928 },
  { area_code: '540', city: 'Roanoke', state: 'VA', lat: 37.2785, lng: -79.9582 },
  { area_code: '541', city: 'Eugene', state: 'OR', lat: 44.0568, lng: -123.119 },
  { area_code: '551', city: 'Jersey City', state: 'NJ', lat: 40.7114, lng: -74.0648 },
  { area_code: '557', city: 'St. Louis', state: 'MO', lat: 38.6357, lng: -90.2446 },
  { area_code: '559', city: 'Fresno', state: 'CA', lat: 36.7827, lng: -119.7934 },
  { area_code: '561', city: 'West Palm Beach', state: 'FL', lat: 26.7153, lng: -80.0534 },
  { area_code: '562', city: 'Long Beach', state: 'CA', lat: 33.7808, lng: -118.1682 },
  { area_code: '563', city: 'Davenport', state: 'IA', lat: 41.5568, lng: -90.6039 },
  { area_code: '564', city: 'Seattle', state: 'WA', lat: 47.6193, lng: -122.3515 },
  { area_code: '567', city: 'Toledo', state: 'OH', lat: 41.6641, lng: -83.5819 },
  { area_code: '570', city: 'Scranton', state: 'PA', lat: 41.4042, lng: -75.6659 },
  { area_code: '571', city: 'Arlington', state: 'VA', lat: 38.8783, lng: -77.1007 },
  { area_code: '572', city: 'Oklahoma City', state: 'OK', lat: 35.4671, lng: -97.5137 },
  { area_code: '573', city: 'Columbia', state: 'MO', lat: 38.9473, lng: -92.3264 },
  { area_code: '574', city: 'South Bend', state: 'IN', lat: 41.6766, lng: -86.2688 },
  { area_code: '575', city: 'Las Cruces', state: 'NM', lat: 32.3264, lng: -106.7897 },
  { area_code: '580', city: 'Lawton', state: 'OK', lat: 34.6172, lng: -98.4214 },
  { area_code: '582', city: 'Erie', state: 'PA', lat: 42.1166, lng: -80.0735 },
  { area_code: '585', city: 'Rochester', state: 'NY', lat: 43.1699, lng: -77.6169 },
  { area_code: '586', city: 'Warren', state: 'MI', lat: 42.4929, lng: -83.025 },
  { area_code: '601', city: 'Jackson', state: 'MS', lat: 32.3158, lng: -90.2129 },
  { area_code: '602', city: 'Phoenix', state: 'AZ', lat: 33.4484, lng: -112.074 },
  { area_code: '603', city: 'Manchester', state: 'NH', lat: 42.9849, lng: -71.4441 },
  { area_code: '605', city: 'Sioux Falls', state: 'SD', lat: 43.5407, lng: -96.732 },
  { area_code: '606', city: 'Ashland', state: 'KY', lat: 38.4595, lng: -82.6451 },
  { area_code: '607', city: 'Binghamton', state: 'NY', lat: 42.1013, lng: -75.9094 },
  { area_code: '608', city: 'Madison', state: 'WI', lat: 43.0878, lng: -89.4299 },
  { area_code: '609', city: 'Trenton', state: 'NJ', lat: 40.2238, lng: -74.7636 },
  { area_code: '610', city: 'Allentown', state: 'PA', lat: 40.5936, lng: -75.4784 },
  { area_code: '612', city: 'Minneapolis', state: 'MN', lat: 44.9633, lng: -93.2683 },
  { area_code: '614', city: 'Columbus', state: 'OH', lat: 39.9839, lng: -82.9849 },
  { area_code: '615', city: 'Nashville', state: 'TN', lat: 36.1718, lng: -86.785 },
  { area_code: '616', city: 'Grand Rapids', state: 'MI', lat: 42.9612, lng: -85.6556 },
  { area_code: '617', city: 'Boston', state: 'MA', lat: 42.3386, lng: -71.0183 },
  { area_code: '618', city: 'East St. Louis', state: 'IL', lat: 38.6164, lng: -90.1305 },
  { area_code: '619', city: 'San Diego', state: 'CA', lat: 32.7157, lng: -117.1647 },
  { area_code: '620', city: 'Dodge City', state: 'KS', lat: 37.7607, lng: -100.0179 },
  { area_code: '623', city: 'Glendale', state: 'AZ', lat: 33.5331, lng: -112.1899 },
  { area_code: '626', city: 'Pasadena', state: 'CA', lat: 34.1606, lng: -118.138 },
  { area_code: '628', city: 'San Francisco', state: 'CA', lat: 37.7749, lng: -122.4194 },
  { area_code: '629', city: 'Nashville', state: 'TN', lat: 36.1718, lng: -86.785 },
  { area_code: '630', city: 'Aurora', state: 'IL', lat: 41.7635, lng: -88.2901 },
  { area_code: '631', city: 'Brentwood', state: 'NY', lat: 40.7839, lng: -73.2522 },
  { area_code: '636', city: 'St. Charles', state: 'MO', lat: 38.7957, lng: -90.5154 },
  { area_code: '640', city: 'Trenton', state: 'NJ', lat: 40.2238, lng: -74.7636 },
  { area_code: '641', city: 'Mason City', state: 'IA', lat: 43.1478, lng: -93.2004 },
  { area_code: '645', city: 'Miami', state: 'FL', lat: 25.7752, lng: -80.2086 },
  { area_code: '646', city: 'New York City', state: 'NY', lat: 40.7143, lng: -74.006 },
  { area_code: '650', city: 'San Mateo', state: 'CA', lat: 37.5603, lng: -122.3106 },
  { area_code: '651', city: 'St. Paul', state: 'MN', lat: 44.9489, lng: -93.1041 },
  { area_code: '656', city: 'Tampa', state: 'FL', lat: 27.9701, lng: -82.4797 },
  { area_code: '657', city: 'Anaheim', state: 'CA', lat: 33.8353, lng: -117.9145 },
  { area_code: '659', city: 'Birmingham', state: 'AL', lat: 33.5272, lng: -86.797 },
  { area_code: '660', city: 'Sedalia', state: 'MO', lat: 38.7052, lng: -93.2358 },
  { area_code: '661', city: 'Bakersfield', state: 'CA', lat: 35.3532, lng: -119.0379 },
  { area_code: '662', city: 'Tupelo', state: 'MS', lat: 34.2706, lng: -88.7325 },
  { area_code: '667', city: 'Baltimore', state: 'MD', lat: 39.3, lng: -76.6105 },
  { area_code: '669', city: 'San Jose', state: 'CA', lat: 37.3394, lng: -121.895 },
  { area_code: '678', city: 'Atlanta', state: 'GA', lat: 33.7629, lng: -84.4227 },
  { area_code: '680', city: 'Syracuse', state: 'NY', lat: 43.041, lng: -76.1436 },
  { area_code: '681', city: 'Charleston', state: 'WV', lat: 38.3487, lng: -81.6323 },
  { area_code: '682', city: 'Fort Worth', state: 'TX', lat: 32.782, lng: -97.3486 },
  { area_code: '689', city: 'Orlando', state: 'FL', lat: 28.5383, lng: -81.3792 },
  { area_code: '701', city: 'Fargo', state: 'ND', lat: 46.8647, lng: -96.8291 },
  { area_code: '702', city: 'Las Vegas', state: 'NV', lat: 36.175, lng: -115.1372 },
  { area_code: '703', city: 'Arlington', state: 'VA', lat: 38.8783, lng: -77.1007 },
  { area_code: '704', city: 'Charlotte', state: 'NC', lat: 35.209, lng: -80.831 },
  { area_code: '706', city: 'Augusta', state: 'GA', lat: 33.471, lng: -81.9748 },
  { area_code: '707', city: 'Santa Rosa', state: 'CA', lat: 38.4458, lng: -122.7062 },
  { area_code: '708', city: 'Cicero', state: 'IL', lat: 41.8445, lng: -87.7593 },
  { area_code: '712', city: 'Sioux City', state: 'IA', lat: 42.4954, lng: -96.3895 },
  { area_code: '713', city: 'Houston', state: 'TX', lat: 29.7857, lng: -95.3888 },
  { area_code: '714', city: 'Anaheim', state: 'CA', lat: 33.8353, lng: -117.9145 },
  { area_code: '715', city: 'Eau Claire', state: 'WI', lat: 44.8183, lng: -91.4948 },
  { area_code: '716', city: 'Buffalo', state: 'NY', lat: 42.8925, lng: -78.8597 },
  { area_code: '717', city: 'Harrisburg', state: 'PA', lat: 40.2759, lng: -76.885 },
  { area_code: '718', city: 'New York City', state: 'NY', lat: 40.7143, lng: -74.006 },
  { area_code: '719', city: 'Colorado Springs', state: 'CO', lat: 38.8673, lng: -104.7607 },
  { area_code: '720', city: 'Denver', state: 'CO', lat: 39.7392, lng: -104.9847 },
  { area_code: '724', city: 'New Castle', state: 'PA', lat: 40.9956, lng: -80.3458 },
  { area_code: '725', city: 'Las Vegas', state: 'NV', lat: 36.175, lng: -115.1372 },
  { area_code: '726', city: 'San Antonio', state: 'TX', lat: 29.4628, lng: -98.5246 },
  { area_code: '727', city: 'St. Petersburg', state: 'FL', lat: 27.7627, lng: -82.6441 },
  { area_code: '728', city: 'West Palm Beach', state: 'FL', lat: 26.7153, lng: -80.0534 },
  { area_code: '730', city: 'Carbondale', state: 'IL', lat: 37.7221, lng: -89.2237 },
  { area_code: '731', city: 'Jackson', state: 'TN', lat: 35.6542, lng: -88.8353 },
  { area_code: '732', city: 'Toms River', state: 'NJ', lat: 39.9949, lng: -74.1878 },
  { area_code: '734', city: 'Ann Arbor', state: 'MI', lat: 42.2761, lng: -83.7309 },
  { area_code: '737', city: 'Austin', state: 'TX', lat: 30.2986, lng: -97.7541 },
  { area_code: '740', city: 'Zanesville', state: 'OH', lat: 39.956, lng: -82.0135 },
  { area_code: '743', city: 'Greensboro', state: 'NC', lat: 36.0949, lng: -79.8236 },
  { area_code: '747', city: 'Los Angeles', state: 'CA', lat: 34.0522, lng: -118.2437 },
  { area_code: '754', city: 'Fort Lauderdale', state: 'FL', lat: 26.1412, lng: -80.1467 },
  { area_code: '757', city: 'Virginia Beach', state: 'VA', lat: 36.8529, lng: -75.978 },
  { area_code: '760', city: 'Palm Springs', state: 'CA', lat: 33.8034, lng: -116.5383 },
  { area_code: '762', city: 'Augusta', state: 'GA', lat: 33.471, lng: -81.9748 },
  { area_code: '763', city: 'Brooklyn Park', state: 'MN', lat: 45.1109, lng: -93.3491 },
  { area_code: '765', city: 'Muncie', state: 'IN', lat: 40.1988, lng: -85.3951 },
  { area_code: '769', city: 'Jackson', state: 'MS', lat: 32.3158, lng: -90.2129 },
  { area_code: '770', city: 'Atlanta', state: 'GA', lat: 33.7629, lng: -84.4227 },
  { area_code: '771', city: 'Washington', state: 'DC', lat: 38.9042, lng: -77.0165 },
  { area_code: '773', city: 'Chicago', state: 'IL', lat: 41.837, lng: -87.6849 },
  { area_code: '774', city: 'Worcester', state: 'MA', lat: 42.2695, lng: -71.8078 },
  { area_code: '775', city: 'Reno', state: 'NV', lat: 39.5491, lng: -119.8499 },
  { area_code: '779', city: 'Rockford', state: 'IL', lat: 42.2593, lng: -89.0635 },
  { area_code: '781', city: 'Newton', state: 'MA', lat: 42.3318, lng: -71.2084 },
  { area_code: '785', city: 'Topeka', state: 'KS', lat: 39.0347, lng: -95.6962 },
  { area_code: '786', city: 'Miami', state: 'FL', lat: 25.7752, lng: -80.2086 },
  { area_code: '801', city: 'Salt Lake City', state: 'UT', lat: 40.7769, lng: -111.931 },
  { area_code: '802', city: 'Burlington', state: 'VT', lat: 44.4919, lng: -73.2389 },
  { area_code: '803', city: 'Columbia', state: 'SC', lat: 34.0007, lng: -81.0348 },
  { area_code: '804', city: 'Richmond', state: 'VA', lat: 37.5314, lng: -77.476 },
  { area_code: '805', city: 'Santa Barbara', state: 'CA', lat: 34.4036, lng: -119.7137 },
  { area_code: '806', city: 'Lubbock', state: 'TX', lat: 33.5619, lng: -101.8889 },
  { area_code: '808', city: 'Honolulu', state: 'HI', lat: 21.3243, lng: -157.8476 },
  { area_code: '810', city: 'Flint', state: 'MI', lat: 43.0244, lng: -83.692 },
  { area_code: '812', city: 'Evansville', state: 'IN', lat: 37.9877, lng: -87.5347 },
  { area_code: '813', city: 'Tampa', state: 'FL', lat: 27.9701, lng: -82.4797 },
  { area_code: '814', city: 'Erie', state: 'PA', lat: 42.1166, lng: -80.0735 },
  { area_code: '815', city: 'Rockford', state: 'IL', lat: 42.2593, lng: -89.0635 },
  { area_code: '816', city: 'Kansas City', state: 'MO', lat: 39.1252, lng: -94.5503 },
  { area_code: '817', city: 'Fort Worth', state: 'TX', lat: 32.782, lng: -97.3486 },
  { area_code: '818', city: 'Los Angeles', state: 'CA', lat: 34.0522, lng: -118.2437 },
  { area_code: '820', city: 'Santa Barbara', state: 'CA', lat: 34.4036, lng: -119.7137 },
  { area_code: '826', city: 'Roanoke', state: 'VA', lat: 37.2785, lng: -79.9582 },
  { area_code: '828', city: 'Asheville', state: 'NC', lat: 35.571, lng: -82.5527 },
  { area_code: '830', city: 'New Braunfels', state: 'TX', lat: 29.6993, lng: -98.1151 },
  { area_code: '831', city: 'Salinas', state: 'CA', lat: 36.6902, lng: -121.6338 },
  { area_code: '832', city: 'Houston', state: 'TX', lat: 29.7857, lng: -95.3888 },
  { area_code: '835', city: 'Allentown', state: 'PA', lat: 40.5936, lng: -75.4784 },
  { area_code: '838', city: 'Albany', state: 'NY', lat: 42.6657, lng: -73.7984 },
  { area_code: '839', city: 'Columbia', state: 'SC', lat: 34.0007, lng: -81.0348 },
  { area_code: '840', city: 'San Bernardino', state: 'CA', lat: 34.1411, lng: -117.2946 },
  { area_code: '843', city: 'Charleston', state: 'SC', lat: 32.828, lng: -79.9729 },
  { area_code: '845', city: 'Poughkeepsie', state: 'NY', lat: 41.6946, lng: -73.9199 },
  { area_code: '847', city: 'Waukegan', state: 'IL', lat: 42.3694, lng: -87.8709 },
  { area_code: '848', city: 'Toms River', state: 'NJ', lat: 39.9949, lng: -74.1878 },
  { area_code: '850', city: 'Tallahassee', state: 'FL', lat: 30.4535, lng: -84.2523 },
  { area_code: '854', city: 'Charleston', state: 'SC', lat: 32.828, lng: -79.9729 },
  { area_code: '856', city: 'Camden', state: 'NJ', lat: 39.9368, lng: -75.1066 },
  { area_code: '857', city: 'Boston', state: 'MA', lat: 42.3386, lng: -71.0183 },
  { area_code: '858', city: 'San Diego', state: 'CA', lat: 32.7157, lng: -117.1647 },
  { area_code: '859', city: 'Lexington', state: 'KY', lat: 38.0407, lng: -84.4583 },
  { area_code: '860', city: 'Hartford', state: 'CT', lat: 41.7659, lng: -72.6816 },
  { area_code: '862', city: 'Newark', state: 'NJ', lat: 40.7242, lng: -74.1726 },
  { area_code: '864', city: 'Greenville', state: 'SC', lat: 34.8369, lng: -82.363 },
  { area_code: '865', city: 'Knoxville', state: 'TN', lat: 35.9707, lng: -83.9493 },
  { area_code: '870', city: 'Jonesboro', state: 'AR', lat: 35.8198, lng: -90.679 },
  { area_code: '872', city: 'Chicago', state: 'IL', lat: 41.837, lng: -87.6849 },
  { area_code: '878', city: 'Pittsburgh', state: 'PA', lat: 40.4399, lng: -79.9757 },
  { area_code: '901', city: 'Memphis', state: 'TN', lat: 35.1495, lng: -90.049 },
  { area_code: '903', city: 'Tyler', state: 'TX', lat: 32.3173, lng: -95.3059 },
  { area_code: '904', city: 'Jacksonville', state: 'FL', lat: 30.3369, lng: -81.6616 },
  { area_code: '906', city: 'Marquette', state: 'MI', lat: 46.5507, lng: -87.3958 },
  { area_code: '907', city: 'Anchorage', state: 'AK', lat: 61.2181, lng: -149.9003 },
  { area_code: '908', city: 'Elizabeth', state: 'NJ', lat: 40.6664, lng: -74.1935 },
  { area_code: '909', city: 'San Bernardino', state: 'CA', lat: 34.1411, lng: -117.2946 },
  { area_code: '910', city: 'Fayetteville', state: 'NC', lat: 35.0527, lng: -78.8784 },
  { area_code: '912', city: 'Savannah', state: 'GA', lat: 32.0835, lng: -81.0998 },
  { area_code: '913', city: 'Kansas City', state: 'KS', lat: 39.1142, lng: -94.6275 },
  { area_code: '914', city: 'Yonkers', state: 'NY', lat: 40.9459, lng: -73.8674 },
  { area_code: '915', city: 'El Paso', state: 'TX', lat: 31.7587, lng: -106.4869 },
  { area_code: '916', city: 'Sacramento', state: 'CA', lat: 38.5677, lng: -121.4682 },
  { area_code: '917', city: 'New York City', state: 'NY', lat: 40.7143, lng: -74.006 },
  { area_code: '918', city: 'Tulsa', state: 'OK', lat: 36.154, lng: -95.9928 },
  { area_code: '919', city: 'Raleigh', state: 'NC', lat: 35.8319, lng: -78.641 },
  { area_code: '920', city: 'Green Bay', state: 'WI', lat: 44.5215, lng: -87.9866 },
  { area_code: '925', city: 'Concord', state: 'CA', lat: 37.9722, lng: -122.0016 },
  { area_code: '928', city: 'Flagstaff', state: 'AZ', lat: 35.1852, lng: -111.6207 },
  { area_code: '929', city: 'New York City', state: 'NY', lat: 40.7143, lng: -74.006 },
  { area_code: '930', city: 'Evansville', state: 'IN', lat: 37.9877, lng: -87.5347 },
  { area_code: '931', city: 'Clarksville', state: 'TN', lat: 36.5664, lng: -87.3452 },
  { area_code: '934', city: 'Brentwood', state: 'NY', lat: 40.7839, lng: -73.2522 },
  { area_code: '935', city: 'San Diego', state: 'CA', lat: 32.7157, lng: -117.1647 },
  { area_code: '936', city: 'Conroe', state: 'TX', lat: 30.3287, lng: -95.4846 },
  { area_code: '937', city: 'Dayton', state: 'OH', lat: 39.7847, lng: -84.1996 },
  { area_code: '938', city: 'Huntsville', state: 'AL', lat: 34.7304, lng: -86.5859 },
  { area_code: '940', city: 'Wichita Falls', state: 'TX', lat: 33.9067, lng: -98.5258 },
  { area_code: '941', city: 'Sarasota', state: 'FL', lat: 27.3383, lng: -82.5437 },
  { area_code: '943', city: 'Atlanta', state: 'GA', lat: 33.7629, lng: -84.4227 },
  { area_code: '945', city: 'Dallas', state: 'TX', lat: 32.7933, lng: -96.7665 },
  { area_code: '947', city: 'Troy', state: 'MI', lat: 42.5839, lng: -83.1455 },
  { area_code: '948', city: 'Virginia Beach', state: 'VA', lat: 36.8529, lng: -75.978 },
  { area_code: '949', city: 'Irvine', state: 'CA', lat: 33.6784, lng: -117.7713 },
  { area_code: '951', city: 'Riverside', state: 'CA', lat: 33.9381, lng: -117.3932 },
  { area_code: '952', city: 'Bloomington', state: 'MN', lat: 44.8297, lng: -93.3152 },
  { area_code: '954', city: 'Fort Lauderdale', state: 'FL', lat: 26.1412, lng: -80.1467 },
  { area_code: '956', city: 'Laredo', state: 'TX', lat: 27.5604, lng: -99.4892 },
  { area_code: '959', city: 'Hartford', state: 'CT', lat: 41.7659, lng: -72.6816 },
  { area_code: '970', city: 'Fort Collins', state: 'CO', lat: 40.5482, lng: -105.0648 },
  { area_code: '971', city: 'Portland', state: 'OR', lat: 45.537, lng: -122.65 },
  { area_code: '972', city: 'Dallas', state: 'TX', lat: 32.7933, lng: -96.7665 },
  { area_code: '973', city: 'Newark', state: 'NJ', lat: 40.7242, lng: -74.1726 },
  { area_code: '975', city: 'Kansas City', state: 'MO', lat: 39.1252, lng: -94.5503 },
  { area_code: '978', city: 'Lowell', state: 'MA', lat: 42.639, lng: -71.321 },
  { area_code: '979', city: 'College Station', state: 'TX', lat: 30.5852, lng: -96.2964 },
  { area_code: '980', city: 'Charlotte', state: 'NC', lat: 35.209, lng: -80.831 },
  { area_code: '983', city: 'Denver', state: 'CO', lat: 39.7392, lng: -104.9847 },
  { area_code: '984', city: 'Raleigh', state: 'NC', lat: 35.8319, lng: -78.641 },
  { area_code: '985', city: 'Houma', state: 'LA', lat: 29.5787, lng: -90.708 },
  { area_code: '986', city: 'Boise', state: 'ID', lat: 43.5993, lng: -116.2298 },
  { area_code: '989', city: 'Saginaw', state: 'MI', lat: 43.4199, lng: -83.9502 }
]

const AREA_CODES_BY_CODE = new Map(US_AREA_CODES.map(row => [row.area_code, row]))

export function metroCenter(areaCode) {
  const row = AREA_CODES_BY_CODE.get(areaCode)
  return row ? [row.lat, row.lng] : null
}
